import api from 'api/user';
import Cookies from 'js-cookie';
import router from '../router'
const actions = {
  getuserInfo,
};
//登录
function getuserInfo({ commit, dispatch }, params) {
  return new Promise(resolve => {
    api
      .getUserInfo(params)
      .then(res => {
        resolve(res);
        //设置信息
        setStoarge(res);
        commit('setUserInfo', res)
        commit('setIFBindPhone', res.mobilePhone)
      })
      .catch(res => {
        resolve(res);
      });
  });
}

function setStoarge(info) {
  if(!info.mobilePhone) {
    localStorage.setItem('ifBindPhone', '0')
  }else{
    localStorage.setItem('ifBindPhone', '1')
  }
  if (info.state === 2) {
    router.push({
      name: 'home'
    })
    alert('该账号已被禁用')
    localStorage.setItem('ifDisable', '1')
  }else{
    localStorage.setItem('ifDisable', '0')
  }
}
export default actions;
